<template>
	<div
		:class="
			cn(
				'flex w-full flex-col items-center justify-center gap-5',
				wrapperClasses
			)
		"
	>
		<div
			:class="
				cn(
					'grid size-[76px] place-items-center rounded-full bg-white-dark-2',
					iconWrapperClasses
				)
			"
		>
			<div
				:class="
					cn(
						'grid size-[70%] place-items-center rounded-full bg-white-dark-4',
						iconSubWrapperClasses
					)
				"
			>
				<slot name="icon"> </slot>
			</div>
		</div>

		<div class="space-y-2 text-center">
			<p
				:class="
					cn(
						'font-matter-sq text-xl font-normal leading-normal tracking-[-0.4px] text-primary',
						titleClasses
					)
				"
			>
				<slot name="title" />
			</p>

			<p
				:class="
					cn(
						'text-sm font-normal leading-normal text-primary md:text-base',
						descriptionClasses
					)
				"
			>
				<slot name="description" />
			</p>
		</div>
		<slot name="cta" />
	</div>
</template>

<script setup lang="ts">
import type { StatusMessageDisplayProps } from '.';

import { cn } from '@/utils';

withDefaults(defineProps<StatusMessageDisplayProps>(), {});
</script>
